export const COUNTRY_CODES = {
  US: `US`,
  GB: `GB`,
  AU: `AU`,
  BD: `BD`,
  PT: `PT`,
  BR: `BR`,
  DE: `DE`,
  AT: `AT`,
  CH: `CH`,
  LI: `LI`,
  LU: `LU`,
  ES: `ES`,
  MX: `MX`,
  AR: `AR`,
  CL: `CL`,
  CO: `CO`,
  FR: `FR`,
  CA: `CA`,
  BE: `BE`,
  IT: `IT`,
  SM: `SM`,
  VA: `VA`,
  JP: `JP`,
  IN: `IN`,
  KE: `KE`,
  NG: `NG`,
  GH: `GH`,
  CM: `CM`,
  UG: `UG`,
  TZ: `TZ`,
  AO: `AO`,
  MZ: `MZ`,
  IR: `IR`,
  ID: `ID`,
  AE: `AE`,
  SA: `SA`,
  QA: `QA`,
  OM: `OM`,
  KW: `KW`,
  BH: `BH`,
  LB: `LB`,
  JO: `JO`,
  EG: `EG`,
  PK: `PK`,
  CN: `CN`,
  HK: `HK`,
  MO: `MO`,
  SG: `SG`,
  TW: `TW`,
  TH: `TH`,
  VN: `VN`,
  RO: `RO`,
  MD: `MD`,
  NL: `NL`,
  SE: `SE`,
  NO: `NO`,
  DK: `DK`,
  FI: `FI`,
  IS: `IS`,
  EE: `EE`,
  LV: `LV`,
  LT: `LT`,
  PL: `PL`,
  UA: `UA`,
  RU: `RU`,
  KZ: `KZ`,
  MA: `MA`,
  KR: `KR`,
  TR: `TR`,
  PH: `PH`,
} as const;

export type CountryCode = (typeof COUNTRY_CODES)[keyof typeof COUNTRY_CODES];

export const COUNTRY_CODE_LIST = Object.values(COUNTRY_CODES);
